// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"8de6edbe","513":"7de36bec","703":"739fb472"}[chunkId] + ".chunk.js";
};